import {useEffect, useRef, useState} from 'react'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import {useFormik} from 'formik'
import CreateAgreementStep1 from './Components/CreateAgreementStep1'
import {useDropzone} from 'react-dropzone'
import CreateAgreementStep3 from './Components/CreateAgreementStep3'
import CreateAgreementStep4 from './Components/CreateAgreementStep4'
import CreateAgreementStep2 from './Components/CreateAgreementStep2'
import CreateAgreementStep5 from './Components/CreateAgreementStep5'
import {getDocumentTemplate, submitDocSigning, templateSigning} from './agreementAPI'
import Swal from 'sweetalert2'
import {
  furnitureDataType,
  provinceDataType,
  signerDataType,
  templateDataType,
  witnessDataType,
} from './agreementDataType'
import {createAgreementValidationSchema} from './agreementValidationSchema'
import {propertyListDataType} from '../ticketing/TicketingDataType'
import {getListProperty} from '../ticketing/TicketingAPI'
import {CircularProgress} from '@mui/material'
import {Link, useNavigate} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import {Get_Province} from '../property/Property_Api'

const AgreementHome = () => {
  const {state} = useLocation()
  const navigate = useNavigate()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [agreementGeneratedDate, setAgreementGeneratedDate] = useState<Date | null>(null)
  const [agreementStartDate, setAgreementStartDate] = useState<Date | null>(null)
  const [agreementEndDate, setAgreementEndDate] = useState<Date | null>(null)
  const [submitBtnLoading, setSubmitBtnLoading] = useState<boolean>(false)
  const [propertyList, setPropertyList] = useState<propertyListDataType[]>([])
  const [province, setProvince] = useState<provinceDataType[]>([])
  const [templateData, setTemplateData] = useState<templateDataType[]>()
  const [furnitureInitialFields, setFurnitureInitialFields] = useState<furnitureDataType[]>([])
  const [witnessInitialFields, setWitnessInitialFields] = useState<witnessDataType[]>([])
  const [signersInitialFields, setSignersInitialFields] = useState<signerDataType[]>([
    {
      name: '',
      identifier: '',
      identifier_type: 'email',
      sign_type: '',
      reason: '',
    },
    {
      name: '',
      identifier: '',
      identifier_type: 'email',
      sign_type: '',
      reason: '',
    },
  ])

  // function to get all properties for agreement
  const getPropertyList = async () => {
    try {
      const {data: response} = await getListProperty()
      if (response.code === '200') {
        setPropertyList(response.data)
      } else if (response.code === '204') {
        setPropertyList(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  // function to get all states from India
  const getProvinceList = async () => {
    try {
      const {data: response} = await Get_Province(1)
      if (response.code === '200') {
        setProvince(response.data)
      } else if (response.code === '204') {
        setProvince(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  // function to get all properties for agreement
  const getListDocumentTemplate = async () => {
    try {
      const {data: response} = await getDocumentTemplate()
      if (response.code === '200') {
        setTemplateData(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      try {
        await Promise.all([getPropertyList(), getProvinceList(), getListDocumentTemplate()])
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }
    loadStepper()
  }, [stepperRef])

  // dropzone code start
  const {acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive} = useDropzone({
    maxFiles: 1,
    accept: {
      'application/pdf': [],
    },
  })

  const acceptedFileItems = acceptedFiles.map((file: File) => {
    return (
      // @ts-ignore
      <li key={file.path}>
        {
          // @ts-ignore
          file.path
        }{' '}
        - {file.size} bytes
      </li>
    )
  })

  const fileRejectionItems = fileRejections.map(({file, errors}) => (
    // @ts-ignore
    <li key={file.path}>
      {
        // @ts-ignore
        file.path
      }{' '}
      - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ))
  // dropzone code ends

  // formik initial values
  const createAgreementInitialValues = {
    // state?.propertyDetails.property_uuid ? state.propertyDetails.property_uuid :
    property_uuid: state?.propertyDetails.property_uuid ? state.propertyDetails.property_uuid : '',
    agreement_type: '',
    file_data: '',
    signers: signersInitialFields,
    witness: witnessInitialFields,
    sign_on_page: '',
    is_estamp: '',
    estamp_state: '',
    estamp_amount: '',
    document_signing_template_uuid: '',
    lessor_courtesy_titles: '',
    lessor_full_name: '',
    lessor_age: '', // number
    lessor_address_1: '',
    lessor_address_2: '',
    lessor_address_city: '',
    lessor_address_state: '',
    lessor_address_pincode: '',
    lessor_pan: '',
    lessee_courtesy_titles: '',
    lessee_full_name: '',
    lessee_age: '', // number
    lessee_address_1: '',
    lessee_address_2: '',
    lessee_address_city: '',
    lessee_address_state: '',
    lessee_address_pincode: '',
    lessee_pan: '',
    lessee_mobiles: '',
    lessee_email_id: '',
    lessee_aadhar: '',
    property_address_1: state?.propertyDetails.address_1 ? state.propertyDetails.address_1 : '',
    property_address_2: state?.propertyDetails.address_2 ? state.propertyDetails.address_2 : '',
    property_address_city: state?.propertyDetails.city ? state.propertyDetails.city : '',
    property_address_state: state?.propertyDetails.province_name
      ? state.propertyDetails.province_name
      : '',
    property_address_pincode: state?.propertyDetails.pin_zip ? state.propertyDetails.pin_zip : '',
    property_rent_day: '', // number
    property_rent_monthly_amount: '', // number
    property_rent_monthly_amount_words: '',
    property_advance_amount: '', // number
    property_advance_amount_words: '',
    account_holder_courtesy_titles: '',
    account_holder_name: '',
    account_holder_pan: '',
    account_number: '',
    account_bank_name: '',
    account_bank_branch_name: '',
    account_bank_ifsc: '',
    rent_agreement_start_date: '',
    rent_agreement_end_date: '',
    witness1_address_1: '',
    witness1_address_2: '',
    witness1_address_city: '',
    witness1_address_state: '',
    witness1_address_pincode: '',
    witness2_address_1: '',
    witness2_address_2: '',
    witness2_address_city: '',
    witness2_address_state: '',
    witness2_address_pincode: '',
    property_short_description: state?.propertyDetails
      ? `A ${state.propertyDetails.property_usage_type === 1 ? 'residential' : 'commercial'} ${
          state.propertyDetails.property_type_name
        } named "${
          state.propertyDetails.property_title.charAt(0).toUpperCase() +
          state.propertyDetails.property_title.slice(1)
        }" spanning ${state.propertyDetails.carpet_area} ${
          state.propertyDetails.carpet_area_unit_name
        } located at ${state.propertyDetails.city}, ${state.propertyDetails.country_name}`
      : '',
    agreement_generated_date: '',
    agreement_generated_city: '',
    agreement_jurisdiction_city: '',
    furnished_room_details: furnitureInitialFields,
  }

  //  formik submit function for create agreement
  const handleSubmitDocSigning = async () => {
    setSubmitBtnLoading(true)
    const formattedSigners = formik.values.signers.map((item) => {
      const newItem = {...item}
      if (item.identifier_type === 'phone') {
        newItem.identifier = newItem.identifier.split(' ')[1].replace('-', '')
      }
      const {identifier_type, ...rest} = newItem
      return rest
    })
    let formattedWitness: witnessDataType[] = []
    if (formik.values.witness.length > 0) {
      formattedWitness = formik.values.witness.map((item) => {
        const newItem = {...item}
        if (item.identifier_type === 'phone') {
          newItem.identifier = newItem.identifier.split(' ')[1].replace('-', '')
        }
        const {identifier_type, ...rest} = newItem
        return rest
      })
    }

    if (formik.values.agreement_type === 'create') {
      try {
        const {data: res} = await templateSigning(
          formik.values.document_signing_template_uuid,
          formattedSigners[0],
          formattedSigners[1],
          formik.values.sign_on_page,
          formik.values.is_estamp === 'true' ? true : false,
          formik.values.estamp_amount ? parseInt(formik.values.estamp_amount, 10) : 0,
          0,
          formik.values.estamp_state ? parseInt(formik.values.estamp_state, 10) : 0,
          formik.values.property_uuid,
          formik.values.lessor_courtesy_titles,
          formik.values.lessor_full_name,
          parseInt(formik.values.lessor_age, 10),
          formik.values.lessor_address_1,
          formik.values.lessor_address_2,
          formik.values.lessor_address_city,
          formik.values.lessor_address_state,
          formik.values.lessor_address_pincode,
          formik.values.lessor_pan,
          formik.values.lessee_courtesy_titles,
          formik.values.lessee_full_name,
          parseInt(formik.values.lessee_age, 10),
          formik.values.lessee_address_1,
          formik.values.lessee_address_2,
          formik.values.lessee_address_city,
          formik.values.lessee_address_state,
          formik.values.lessee_address_pincode,
          formik.values.lessee_pan,
          formik.values.lessee_mobiles.split(' ')[1].replace('-', ''),
          formik.values.lessee_email_id,
          formik.values.lessee_aadhar,
          formik.values.property_address_1,
          formik.values.property_address_2,
          formik.values.property_address_city,
          formik.values.property_address_state,
          formik.values.property_address_pincode,
          parseInt(formik.values.property_rent_day, 10),
          parseInt(formik.values.property_rent_monthly_amount, 10),
          formik.values.property_rent_monthly_amount_words,
          parseInt(formik.values.property_advance_amount, 10),
          formik.values.property_advance_amount_words,
          formik.values.account_holder_courtesy_titles,
          formik.values.account_holder_name,
          formik.values.account_holder_pan,
          formik.values.account_number,
          formik.values.account_bank_name,
          formik.values.account_bank_branch_name,
          formik.values.account_bank_ifsc,
          formik.values.rent_agreement_start_date,
          formik.values.rent_agreement_end_date,
          formik.values.property_short_description,
          formik.values.agreement_generated_date,
          formik.values.agreement_generated_city,
          formik.values.agreement_jurisdiction_city,
          formattedWitness[0] ? formattedWitness[0] : '',
          formattedWitness[1] ? formattedWitness[1] : '',
          formik.values.witness1_address_1 ? formik.values.witness1_address_1 : '',
          formik.values.witness1_address_2 ? formik.values.witness1_address_2 : '',
          formik.values.witness1_address_city ? formik.values.witness1_address_city : '',
          formik.values.witness1_address_state ? formik.values.witness1_address_state : '',
          formik.values.witness1_address_pincode ? formik.values.witness1_address_pincode : '',
          formik.values.witness2_address_1 ? formik.values.witness2_address_1 : '',
          formik.values.witness2_address_2 ? formik.values.witness2_address_2 : '',
          formik.values.witness2_address_city ? formik.values.witness2_address_city : '',
          formik.values.witness2_address_state ? formik.values.witness2_address_state : '',
          formik.values.witness2_address_pincode ? formik.values.witness2_address_pincode : '',
          formik.values.furnished_room_details ? formik.values.furnished_room_details : ''
        )
        if (res.code === '200') {
          if (state?.propertyDetails?.property_uuid) {
            navigate(`/property/${state?.propertyDetails?.property_uuid}/agreement`)
          } else {
            stepper?.current?.goto(1)
            formik.resetForm()
            acceptedFiles.pop()
            setSignersInitialFields([
              {
                name: '',
                identifier: '',
                identifier_type: 'email',
                sign_type: '',
                reason: '',
              },
              {
                name: '',
                identifier: '',
                identifier_type: 'email',
                sign_type: '',
                reason: '',
              },
            ])
            setWitnessInitialFields([])
            setFurnitureInitialFields([])
            setAgreementGeneratedDate(null)
            setAgreementStartDate(null)
            setAgreementEndDate(null)
          }
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
            allowOutsideClick: true,
          })
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: error,
          allowOutsideClick: true,
        })
      } finally {
        setSubmitBtnLoading(false)
      }
    } else {
      let base64String: string = ''
      if (acceptedFiles.length === 1) {
        base64String = await new Promise((resolve) => {
          const reader = new FileReader()
          reader.onload = (event) => {
            const result = event.target!.result as string
            const base64String = result.split(',')[1]
            resolve(base64String)
          }
          reader.readAsDataURL(acceptedFiles[0])
        })
      }
      try {
        const {data: res} = await submitDocSigning(
          formik.values.property_uuid,
          formattedSigners,
          formattedWitness,
          formik.values.sign_on_page,
          formik.values.is_estamp === 'true' ? true : false,
          formik.values.estamp_amount ? parseInt(formik.values.estamp_amount, 10) : '',
          1,
          formik.values.estamp_state ? parseInt(formik.values.estamp_state, 10) : '',
          base64String
        )
        if (res.code === '200') {
          if (state?.propertyDetails?.property_uuid) {
            navigate(`/property/${state?.propertyDetails?.property_uuid}/agreement`)
          } else {
            stepper?.current?.goto(1)
            formik.resetForm()
            acceptedFiles.pop()
            setSignersInitialFields([
              {
                name: '',
                identifier: '',
                identifier_type: 'email',
                sign_type: '',
                reason: '',
              },
              {
                name: '',
                identifier: '',
                identifier_type: 'email',
                sign_type: '',
                reason: '',
              },
            ])
            setWitnessInitialFields([])
            setFurnitureInitialFields([])
            setAgreementGeneratedDate(null)
            setAgreementStartDate(null)
            setAgreementEndDate(null)
          }
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
            allowOutsideClick: true,
          })
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: error,
          allowOutsideClick: true,
        })
      } finally {
        setSubmitBtnLoading(false)
      }
    }
  }

  // formik object for create agreement
  const formik = useFormik({
    initialValues: createAgreementInitialValues,
    validationSchema: createAgreementValidationSchema,
    onSubmit: () => console.log(),
  })

  // function to check step1 validations
  const checkCreateAgreementStep1 = () => {
    if (
      formik.values.property_uuid &&
      formik.values.agreement_type &&
      !formik.errors.property_uuid &&
      !formik.errors.agreement_type
    ) {
      if (formik.values.agreement_type === 'create' && !formik.errors.agreement_type) {
        if (
          formik.values.document_signing_template_uuid &&
          !formik.errors.document_signing_template_uuid
        ) {
          return true
        } else {
          formik.setTouched(
            {
              property_uuid: true,
              agreement_type: true,
              document_signing_template_uuid: true,
            },
            true
          )
          return false
        }
      } else if (formik.values.agreement_type === 'upload' && !formik.errors.agreement_type) {
        if (acceptedFiles.length > 0) {
          formik.setFieldError('file_data', '')
          // formik.setFieldValue('file_data', acceptedFiles[0].name, true)
          return true
        } else {
          formik.setTouched(
            {
              property_uuid: true,
              agreement_type: true,
              file_data: true,
            },
            true
          )
          return false
        }
      }
    } else {
      formik.setTouched(
        {
          property_uuid: true,
          agreement_type: true,
          document_signing_template_uuid: true,
          file_data: true,
        },
        true
      )
      return false
    }
  }

  // function to check step2 validations
  const checkCreateAgreementStep2 = () => {
    if (
      formik.values.lessor_courtesy_titles &&
      formik.values.lessor_full_name &&
      formik.values.lessor_age &&
      formik.values.lessor_address_1 &&
      formik.values.lessor_address_2 &&
      formik.values.lessor_address_city &&
      formik.values.lessor_address_state &&
      formik.values.lessor_address_pincode &&
      formik.values.lessor_pan &&
      formik.values.lessee_courtesy_titles &&
      formik.values.lessee_full_name &&
      formik.values.lessee_age &&
      formik.values.lessee_address_1 &&
      formik.values.lessee_address_2 &&
      formik.values.lessee_address_city &&
      formik.values.lessee_address_state &&
      formik.values.lessee_address_pincode &&
      formik.values.lessee_pan &&
      formik.values.lessee_mobiles &&
      formik.values.lessee_email_id &&
      formik.values.lessee_aadhar &&
      formik.values.property_address_1 &&
      formik.values.property_address_2 &&
      formik.values.property_address_city &&
      formik.values.property_address_state &&
      formik.values.property_address_pincode &&
      formik.values.property_rent_day &&
      formik.values.property_rent_monthly_amount &&
      formik.values.property_rent_monthly_amount_words &&
      formik.values.property_advance_amount &&
      formik.values.property_advance_amount_words &&
      formik.values.account_holder_courtesy_titles &&
      formik.values.account_holder_name &&
      formik.values.account_holder_pan &&
      formik.values.account_number &&
      formik.values.account_bank_name &&
      formik.values.account_bank_branch_name &&
      formik.values.account_bank_ifsc &&
      formik.values.rent_agreement_start_date &&
      formik.values.rent_agreement_end_date &&
      formik.values.property_short_description &&
      formik.values.agreement_generated_date &&
      formik.values.agreement_generated_city &&
      formik.values.agreement_jurisdiction_city &&
      formik.values.furnished_room_details &&
      !formik.errors.lessor_courtesy_titles &&
      !formik.errors.lessor_full_name &&
      !formik.errors.lessor_age &&
      !formik.errors.lessor_address_1 &&
      !formik.errors.lessor_address_2 &&
      !formik.errors.lessor_address_city &&
      !formik.errors.lessor_address_state &&
      !formik.errors.lessor_address_pincode &&
      !formik.errors.lessor_pan &&
      !formik.errors.lessee_courtesy_titles &&
      !formik.errors.lessee_full_name &&
      !formik.errors.lessee_age &&
      !formik.errors.lessee_address_1 &&
      !formik.errors.lessee_address_2 &&
      !formik.errors.lessee_address_city &&
      !formik.errors.lessee_address_state &&
      !formik.errors.lessee_address_pincode &&
      !formik.errors.lessee_pan &&
      !formik.errors.lessee_mobiles &&
      !formik.errors.lessee_email_id &&
      !formik.errors.lessee_aadhar &&
      !formik.errors.property_address_1 &&
      !formik.errors.property_address_2 &&
      !formik.errors.property_address_city &&
      !formik.errors.property_address_state &&
      !formik.errors.property_address_pincode &&
      !formik.errors.property_rent_day &&
      !formik.errors.property_rent_monthly_amount &&
      !formik.errors.property_rent_monthly_amount_words &&
      !formik.errors.property_advance_amount &&
      !formik.errors.property_advance_amount_words &&
      !formik.errors.account_holder_courtesy_titles &&
      !formik.errors.account_holder_name &&
      !formik.errors.account_holder_pan &&
      !formik.errors.account_number &&
      !formik.errors.account_bank_name &&
      !formik.errors.account_bank_branch_name &&
      !formik.errors.account_bank_ifsc &&
      !formik.errors.rent_agreement_start_date &&
      !formik.errors.rent_agreement_end_date &&
      !formik.errors.property_short_description &&
      !formik.errors.agreement_generated_date &&
      !formik.errors.agreement_generated_city &&
      !formik.errors.agreement_jurisdiction_city &&
      !formik.errors.furnished_room_details
    ) {
      return true
    } else {
      formik.setTouched(
        {
          lessor_courtesy_titles: true,
          lessor_full_name: true,
          lessor_age: true,
          lessor_address_1: true,
          lessor_address_2: true,
          lessor_address_city: true,
          lessor_address_state: true,
          lessor_address_pincode: true,
          lessor_pan: true,
          lessee_courtesy_titles: true,
          lessee_full_name: true,
          lessee_age: true,
          lessee_address_1: true,
          lessee_address_2: true,
          lessee_address_city: true,
          lessee_address_state: true,
          lessee_address_pincode: true,
          lessee_pan: true,
          lessee_mobiles: true,
          lessee_email_id: true,
          lessee_aadhar: true,
          property_address_1: true,
          property_address_2: true,
          property_address_city: true,
          property_address_state: true,
          property_address_pincode: true,
          property_rent_day: true,
          property_rent_monthly_amount: true,
          property_rent_monthly_amount_words: true,
          property_advance_amount: true,
          property_advance_amount_words: true,
          account_holder_courtesy_titles: true,
          account_holder_name: true,
          account_holder_pan: true,
          account_number: true,
          account_bank_name: true,
          account_bank_branch_name: true,
          account_bank_ifsc: true,
          rent_agreement_start_date: true,
          rent_agreement_end_date: true,
          property_short_description: true,
          agreement_generated_date: true,
          agreement_generated_city: true,
          agreement_jurisdiction_city: true,
        },
        true
      )
      if (furnitureInitialFields.length > 0) {
        furnitureInitialFields.forEach((room, index) => {
          Object.keys(room).forEach((fieldName) => {
            formik.setFieldTouched(`furnished_room_details[${index}].${fieldName}`, true)
          })
        })
      }
      return false
    }
  }

  // function to create step3 validations
  const checkCreateAgreementStep3 = () => {
    if (
      formik.values.signers &&
      formik.values.witness &&
      !formik.errors.signers &&
      !formik.errors.witness
    ) {
      return true
    } else {
      signersInitialFields.forEach((signer, index) => {
        Object.keys(signer).forEach((fieldName) => {
          formik.setFieldTouched(`signers[${index}].${fieldName}`, true)
        })
      })
      if (witnessInitialFields.length > 0) {
        witnessInitialFields.forEach((witness, index) => {
          Object.keys(witness).forEach((fieldName) => {
            formik.setFieldTouched(`witness[${index}].${fieldName}`, true)
          })
        })
      }
      return false
    }
  }

  // function to create step4 validations
  const checkCreateAgreementStep4 = () => {
    if (
      formik.values.sign_on_page &&
      formik.values.is_estamp &&
      !formik.errors.sign_on_page &&
      !formik.errors.is_estamp
    ) {
      if (formik.values.is_estamp === 'true') {
        if (
          formik.values.estamp_amount &&
          formik.values.estamp_state &&
          !formik.errors.estamp_amount &&
          !formik.errors.estamp_state
        ) {
          return true
        } else {
          formik.setTouched(
            {
              sign_on_page: true,
              is_estamp: true,
              estamp_amount: true,
              estamp_state: true,
            },
            true
          )
          return false
        }
      } else if (formik.values.is_estamp === 'false') {
        return true
      }
    } else {
      formik.setTouched(
        {
          sign_on_page: true,
          is_estamp: true,
          estamp_amount: true,
          estamp_state: true,
        },
        true
      )
      return false
    }
  }

  // function to go to previous step
  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 3 && formik.values.agreement_type === 'upload') {
      stepper?.current?.goto(1)
      return
    }
    stepper.current.goPrev()
  }

  // function to go to next step
  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 1) {
      if (!checkCreateAgreementStep1()) {
        return
      }
      if (formik.values.agreement_type === 'upload') {
        stepper?.current?.goto(3)
        window.scrollTo({
          top: 0,
        })
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 2) {
      if (!checkCreateAgreementStep2()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkCreateAgreementStep3()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 4) {
      if (!checkCreateAgreementStep4()) {
        return
      }
    }
    stepper.current.goNext()
    window.scrollTo({
      top: 0,
    })
  }

  // function to go to steps onclick of stepper headings
  const handleGoto = (val: number) => {
    let valid: number = 0
    if (val >= 1) {
      if (!checkCreateAgreementStep1()) {
        stepper?.current?.goto(1)
        checkCreateAgreementStep1()
        return
      } else if (val === 1 && valid === 0) {
        stepper?.current?.goto(1)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 2) {
      if (formik.values.agreement_type === 'create') {
        if (!checkCreateAgreementStep2()) {
          stepper?.current?.goto(2)
          checkCreateAgreementStep2()
          return
        } else if (val === 2 && valid === 1) {
          stepper?.current?.goto(2)
          return
        } else {
          valid = valid + 1
        }
      } else {
        valid = valid + 1
      }
    }
    if (val >= 3) {
      if (!checkCreateAgreementStep3()) {
        stepper?.current?.goto(3)
        checkCreateAgreementStep3()
        return
      } else if (val === 3 && valid === 2) {
        stepper?.current?.goto(3)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 4) {
      if (!checkCreateAgreementStep4()) {
        stepper?.current?.goto(4)
        checkCreateAgreementStep4()
        return
      } else if (val === 4 && valid === 3) {
        stepper?.current?.goto(4)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val === 5) {
      if (valid === 4) {
        stepper?.current?.goto(5)
        return
      }
    }
    return
  }
  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-row flex-column flex-xl-row flex-row-fluid w-100'
          id='kt_create_account_stepper'
        >
          {/* Begin: Header for create agreement page */}
          <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between px-5'>
            {/* Begin: Heading */}
            <h1
              className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center mb-5'
            >
              Create Agreement
            </h1>
            {/* End: Heading */}
          </div>
          {/* End: Header for create agreement page */}

          {/* Begin: Content of the create agreement page */}
          <div className={`${propertyList.length <= 0 && 'd-none'}`}>
            {/* begin::Aside*/}
            <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 me-9 mb-4'>
              {/* begin::Wrapper*/}
              <div className='card-body px-6 px-lg-10 px-xxl-15 py-5'>
                {/* begin::Nav*/}
                <div className='stepper-nav'>
                  {/* begin::Step 1*/}
                  <div
                    className='stepper-item current position-relative w-25'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(1)}>
                      <div className='d-flex'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>1</span>
                        </div>
                        <div className='position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label'>
                        <h3 className='stepper-title'>Basic Details</h3>

                        <div className='stepper-desc fw-semibold fs-8'>Enter Basic Details</div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                  </div>
                  {/* end::Step 1*/}
                  {/* begin::Step 2*/}
                  <div
                    className='stepper-item position-relative w-25'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(2)}>
                      <div className='d-flex'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>2</span>
                        </div>
                        <div className='position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label'>
                        <h3
                          className={`stepper-title ${
                            formik.values.agreement_type === 'upload' && 'text-secondary'
                          }`}
                        >
                          Template Details
                        </h3>

                        <div className='stepper-desc fw-semibold fs-8'>
                          {formik.values.agreement_type === 'upload'
                            ? 'Not Required'
                            : 'Enter Template Details'}
                        </div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                  </div>
                  {/* end::Step 2*/}
                  {/* begin::Step 3*/}
                  <div
                    className='stepper-item position-relative w-25'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(3)}>
                      <div className='d-flex'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>3</span>
                        </div>
                        <div className='position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label'>
                        <h3 className='stepper-title'>Signers & witness</h3>

                        <div className='stepper-desc fw-semibold fs-8'>
                          Signers and Witness Details
                        </div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                  </div>
                  {/* end::Step 3*/}
                  {/* begin::Step 4*/}
                  <div
                    className='stepper-item position-relative w-25'
                    data-kt-stepper-element='nav'
                  >
                    {/* begin::Wrapper*/}
                    <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(4)}>
                      <div className='d-flex'>
                        {/* begin::Icon*/}
                        <div className='stepper-icon w-40px h-40px mb-2 me-0 z-index-2'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>4</span>
                        </div>
                        <div className='position-absolute h-50 w-100 mb-2 d-flex justify-content-center align-items-center'>
                          <hr className='w-100 align-self-center border-dotted' />
                        </div>
                        {/* end::Icon*/}
                      </div>
                      {/* begin::Label*/}
                      <div className='stepper-label'>
                        <h3 className='stepper-title'>Other Details</h3>

                        <div className='stepper-desc fw-semibold fs-8'>Set Your eStamping</div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}

                    {/* begin::Line*/}
                    <div className='stepper-line h-40px'></div>
                    {/* end::Line*/}
                  </div>
                  {/* end::Step 4*/}
                  {/* begin::Step 5*/}
                  <div className='stepper-item' data-kt-stepper-element='nav'>
                    {/* begin::Wrapper*/}
                    <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(5)}>
                      {/* begin::Icon*/}
                      <div className='stepper-icon w-40px h-40px mb-2'>
                        <i className='stepper-check fas fa-check'></i>
                        <span className='stepper-number'>5</span>
                      </div>
                      {/* end::Icon*/}
                      {/* begin::Label*/}
                      <div className='stepper-label'>
                        <h3 className='stepper-title'>Completed</h3>
                        <div className='stepper-desc fw-semibold fs-8'>Woah, all done</div>
                      </div>
                      {/* end::Label*/}
                    </div>
                    {/* end::Wrapper*/}
                  </div>
                  {/* end::Step 5*/}
                </div>
                {/* end::Nav*/}
              </div>
              {/* end::Wrapper*/}
            </div>
            {/* Begin: form content*/}
            <div className='d-flex w-100 flex-center bg-body rounded'>
              {/* Begin: Form start */}
              <form
                className='py-2 w-100 px-9'
                id='kt_create_account_form'
                onSubmit={formik.handleSubmit}
              >
                {/* Begin: step1 */}
                <div className='current' data-kt-stepper-element='content'>
                  <CreateAgreementStep1
                    templateData={templateData}
                    propertyList={propertyList}
                    formik={formik}
                    acceptedFileItems={acceptedFileItems}
                    fileRejectionItems={fileRejectionItems}
                    getRootProps={getRootProps}
                    isDragActive={isDragActive}
                    getInputProps={getInputProps}
                    acceptedFiles={acceptedFiles}
                  />
                </div>
                {/* End: step1 */}

                {/* Begin: step2 */}
                <div data-kt-stepper-element='content'>
                  <CreateAgreementStep2
                    formik={formik}
                    province={province}
                    furnitureInitialFields={furnitureInitialFields}
                    setFurnitureInitialFields={setFurnitureInitialFields}
                    agreementGeneratedDate={agreementGeneratedDate}
                    setAgreementGeneratedDate={setAgreementGeneratedDate}
                    agreementStartDate={agreementStartDate}
                    setAgreementStartDate={setAgreementStartDate}
                    agreementEndDate={agreementEndDate}
                    setAgreementEndDate={setAgreementEndDate}
                  />
                </div>
                {/* End: step2 */}

                {/* Begin: step3 */}
                <div data-kt-stepper-element='content'>
                  <CreateAgreementStep3
                    formik={formik}
                    signers={signersInitialFields}
                    setSigners={setSignersInitialFields}
                    witness={witnessInitialFields}
                    setWitness={setWitnessInitialFields}
                  />
                </div>
                {/* End: step3 */}

                {/* Begin: step4 */}
                <div data-kt-stepper-element='content'>
                  <CreateAgreementStep4 formik={formik} province={province} />
                </div>
                {/* End: step4 */}

                {/* Begin: step5 */}
                <div data-kt-stepper-element='content'>
                  <CreateAgreementStep5 />
                </div>
                {/* End: step5 */}

                {/* Begin: buttons */}
                <div className='d-flex flex-stack pt-2'>
                  <div className='mr-2'>
                    {/* Begin:: back button */}
                    <button
                      onClick={prevStep}
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                    >
                      <i className='bi bi-arrow-left ms-0 ps-0 me-2'></i>
                      Back
                    </button>
                    {/* End:: back button */}
                  </div>

                  {/* Begin:: Submit and next button div */}
                  <div>
                    {/* Begin:: submit button */}
                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='submit'
                      disabled={submitBtnLoading}
                      onClick={handleSubmitDocSigning}
                    >
                      {submitBtnLoading ? (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Processing...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      ) : (
                        `Submit`
                      )}
                    </button>
                    {/* End:: submit button */}

                    {/* Begin:: next button */}
                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='next'
                      onClick={nextStep}
                    >
                      Next Step
                    </button>
                    {/* End:: next button */}
                  </div>
                </div>
                {/* End: buttons */}
              </form>
              {/* End: Form end */}
            </div>
            {/* End: form content*/}
          </div>
          {/* End: Content of the create agreement page */}

          {/* Begin: Section when properties are not availble */}
          <div className={`card ${propertyList.length > 0 && 'd-none'}`} style={{height: '70vh'}}>
            <span className='d-flex flex-column align-items-center flex-start p-10'>
              <img
                src='/media/svg/undraw/property.svg'
                alt='No document uploaded'
                className='h-200px w-200px'
              />
              <span className='fw-bold text-muted fs-1 text-center'>
                Please add property to create agreement
              </span>
              <Link to='/property' className='mt-6 btn btn-sm fw-bold btn-primary'>
                Add property
              </Link>
            </span>
          </div>
          {/* End: Section when properties are not availble */}
        </div>
      )}
    </>
  )
}

export default AgreementHome
